import { useQuery, UseQueryResult } from '@tanstack/react-query';

import getAllFranchisees from '@/actions/franchisee/getAllFranchisees';
import { PaginatedFranchisees } from '@/types/franchisee.type';
import { ApiResponse } from '@/types/response.type';

export interface UseGetAllFranchiseesParams {
  page?: number;
  limit?: number;
}

export interface UseGetAllFranchiseesReturn {
  result: ApiResponse<PaginatedFranchisees> | undefined;
  error: Error | null;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  isRefetching: boolean;
}

export const useGetAllFranchisees = (
  params: UseGetAllFranchiseesParams = {}
): UseGetAllFranchiseesReturn => {
  const { page = 1, limit = 10 } = params;

  const query: UseQueryResult<
    ApiResponse<PaginatedFranchisees> | undefined,
    Error
  > = useQuery({
    queryKey: ['franchisees', page, limit],
    queryFn: () => getAllFranchisees({ page, limit }),
  });

  return {
    result: query.data,
    error: query.error,
    isError: query.isError,
    isSuccess: query.isSuccess,
    isLoading: query.isPending,
    isRefetching: query.isRefetching,
  };
};
